// import loadingScreen directly so it can render immediately
import { loadingScreen } from './components/LoadingScreen';
loadingScreen.render();

// then lazy load the rest of the app
import(/* webpackChunkName: "app" */ "./main").then((module) => {
    module.loader();
});